export enum TaskSettingsTabs {
  GENERAL = 'general',
  TASK_TAGS = 'task-tags',
  TASK_QUEUE = 'task-queue',
  TASK_RESCHEDULE_REASONS = 'task-reschedule-reasons',
  SEND_ON_BEHALF_OF_PERMISSIONS = 'send-on-behalf-of permissions',
}
